<template>
  <v-card-text class="py-6 px-6" v-if="tactic !== undefined">
    <p class="text-h6 font-weight-light white--text">
      <span class="dw_green--text mr-2">{{ tactic.mitre_id }}</span>
      {{ tactic.name }}
        <v-chip
          label
          outlined
          x-small
          color="grey"
          class="ml-2 text-uppercase">{{ displayMatrix(tactic.mitre_domain) }}</v-chip>
        <v-chip
          v-if="tactic.revoked"
          label
          outlined
          x-small
          color="red accent-2"
          class="ml-2 text-uppercase">Revoked</v-chip>
        <v-chip
          v-if="tactic.deprecated"
          label
          outlined
          x-small
          color="red accent-2"
          class="ml-2 text-uppercase">Deprecated</v-chip>
    </p>
    <p class="body-2 font-weight-light mb-0">
      {{ tactic.description }}
    </p>
  </v-card-text>
</template>

<script>
export default {
  name: 'tacticDetails',
  props: ['tactic'],
  methods: {
    displayMatrix(val) {
      if (val === 'mitre-attack') return 'Enterprise';
      if (val === 'mitre-mobile-attack') return 'Mobile';
      if (val === 'mitre-pre-attack') return 'PRE';
    }
  }
};
</script>
